import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { LowInformationsParams } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-super-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
})
export class ContactListComponent implements OnInit {
  @Input() set searchs(value) {
    this.searchString = value;
    if (this.searchString === '' || this.searchString === null) {
      this.formSearch.patchValue({
        search: '',
      });
    }
  }
  @Input() set items(value: Contact[]) {
    this.contacts = value;
    if (this.triggerSearch && this.formSearch.value.search) {
      this.onSearchField();
    }
    if (!this.formSearch.value.search) {
      this.searchString = 'A';
    }
  }
  @Input() click: (params?) => void;
  @Output() selectedValue: EventEmitter<Contact> = new EventEmitter();
  @Output() scrollEvent: EventEmitter<LowInformationsParams> = new EventEmitter();
  @Output() searchEvent: EventEmitter<LowInformationsParams> = new EventEmitter();
  @Input() active = true;
  @Input() triggerSearch: boolean;
  public alphabets: Array<string> = [];
  public letterModel = '';
  public activeLine = 0;
  public activeContact: number;
  public contacts: Contact[] = [];

  public searchString;
  public pageNumber = 1;
  public params: LowInformationsParams = {
    pageNumber: 1,
    pageSize: 2000,
    sortFields: 'nom',
  };
  public isSearchMode: boolean;
  public searchInField = false;
  public formSearch = new UntypedFormGroup({
    search: new UntypedFormControl(null),
  });
  @HostListener('scroll', ['$event'])
  onScroll(event: { target: { offsetHeight: number; scrollTop: number; scrollHeight: number } }): void {
    // visible height + pixel scrolled >= total height
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 10) {
      this.pageNumber = this.pageNumber + 1;
      this.params.pageNumber = this.pageNumber;
      this.scrollEvent.emit(this.params);
    }
  }

  ngOnInit(): void {
    for (let i = 65; i <= 90; i++) {
      this.alphabets.push(String.fromCharCode(i));
    }
  }

  setActive(value): void {
    this.active = value;
  }

  fct(click, item): void {
    click(item);
    this.selectedValue.emit(item);
  }

  toggleLine(arg): void {
    this.activeContact = arg;
  }

  reset(): void {
    this.searchString = '';
    if (Object.prototype.hasOwnProperty.call(this.params, 'nom')) {
      delete this.params.nom;
    }
    if (Object.prototype.hasOwnProperty.call(this.params, 'nomOperator')) {
      delete this.params.nomOperator;
    }
    if (Object.prototype.hasOwnProperty.call(this.params, 'search')) {
      delete this.params.search;
    }
    if (Object.prototype.hasOwnProperty.call(this.params, 'includeAddressPrincipal')) {
      delete this.params.includeAddressPrincipal;
    }
    this.searchEvent.emit(this.params);
  }

  onSearchField(): void {
    this.isSearchMode = true;
    this.searchString = null;
    this.searchInField = true;

    const data = {
      pageNumber: 1,
      pageSize: 2000,
      sortFields: 'nom',
      search: this.formSearch.value.search,
      includeAddressPrincipal: this.formSearch.value.includeAddressPrincipal,
      nePlusUtiliser: false,
    };
    this.searchInField = false;
    this.searchString = this.formSearch.value.search;
    this.searchEvent.emit(data);
  }
  onSearchLetter(params: { letter: string }): void {
    this.isSearchMode = true;

    const data = {
      pageNumber: 1,
      pageSize: 2000,
      sortFields: 'nom,prenom',
      nom: params.letter,
      nomOperator: 'startWith',
    };
    this.searchEvent.emit(data);
  }
}
